import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TabNotificationService {
  originalFavicon: HTMLLinkElement = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

  unreadCount = signal<number>(0);
  constructor() {
    effect(() => {
      this.updateFaviconWithUnreadCount(this.unreadCount());
    });
  }

  updateFaviconWithUnreadCount(unreadCount: number): void {
    if (!this.originalFavicon) return;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const img = new Image();
    img.src = this.originalFavicon.href;

    img.onload = () => {
      const size = 64;
      canvas.width = size;
      canvas.height = size;

      if (context) {
        context.drawImage(img, 0, 0, size, size);

        if (unreadCount > 0) {
          context.beginPath();
          context.arc(size - 16, 16, 20, 0, 2 * Math.PI);
          context.fillStyle = 'red';
          context.fill();

          context.font = 'bold 20px Arial';
          context.fillStyle = 'white';
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          context.fillText(unreadCount.toString(), size - 16, 16);
        }

        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = canvas.toDataURL('image/png');
        const currentFavicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

        document.head.removeChild(currentFavicon);
        document.head.appendChild(newFavicon);
      }
    };
  }
}
